module.exports = __webpack_public_path__ + "images/interview-AT&T-2.svg";